import Sidebar from '../components/sidebar/Sidebar';
import React, {useState} from 'react';
import Footer from '../components/footer/Footer';
import FormsW2Details from "../components/forms/FormsW2Details";
import NavbarForms from "../components/navbar/NavbarForms";


const FormsW2 = () => {

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    return (
      <>
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <NavbarForms toggle={toggle} />
          <FormsW2Details/>
        <Footer/>
      </>
  );
};

export default FormsW2;
